import React from 'react';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Events = ({ events, onViewAll, onSelect }) => {
  const getEventTypeColor = (type) => {
    return type === 'exam' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700';
  };

  const getEventTypeEmoji = (type) => {
    return type === 'exam' ? '📝' : '💰';
  };

  // Sort events by date
  const sortedEvents = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="bg-white rounded-3xl p-6 shadow-xl shadow-teal-900/5 border border-gray-100/50 lg:col-span-1"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <FaCalendarAlt className="text-teal-600" /> 
          Upcoming Events
        </h3>
        <button 
          onClick={onViewAll}
          className="text-sm text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1"
        >
          View All <FaArrowRight className="text-xs" />
        </button>
      </div>

      <div className="space-y-3">
        {sortedEvents.length === 0 ? (
          <p className="text-gray-500 text-sm text-center py-4">No upcoming events</p>
        ) : (
          sortedEvents.slice(0, 3).map((event, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="p-4 rounded-xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 cursor-pointer hover:shadow-md transition-shadow duration-200"
              onClick={() => onSelect(event)}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${getEventTypeColor(event.type)}`}>
                  {getEventTypeEmoji(event.type)}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-gray-800 text-sm">{event.title}</h4>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${getEventTypeColor(event.type)}`}>
                      {event.type === 'exam' ? 'Exam' : 'Fee'}
                    </span>
                    <span className="text-xs text-gray-500">
                      {new Date(event.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </span>
                    <span className="text-xs text-gray-400">{event.time}</span>
                  </div>
                  {event.subject && (
                    <p className="text-xs text-gray-600 mt-1 truncate">
                      {event.subject}
                    </p>
                  )}
                </div>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </motion.div>
  );
};

export default Events;